/*
    This method breaks the string into an array of chars, building and returning a new string in snake_case (slugified).
    Underscores are introduced in order to separate different words from camel-case format.
    Ex.: A capital letter after a lowercased one from a camel-case format should introduce
    an underscore between them to keep the separation of the different words from the word being slugified
*/
function slugify(value) {
    const tokens = [];
    let current = [];
    value.split('').forEach((symbol) => {
        if (symbol === symbol.toUpperCase() && symbol !== ' ') {
            const lastChar = current[current.length - 1];
            if (current.length === 0 || lastChar === lastChar.toUpperCase()) {
                current.push(symbol);
            } else if (current) {
                tokens.push(current.join(''));
                current = [symbol];
            }
        } else if (symbol.match(/[a-zA-Z0-9]+/)) {
            current.push(symbol);
        } else if (!!current && current.length > 0) {
            tokens.push(current.join(''));
            current = [];
        }
    });
    if (!!current && current.length > 0) {
        tokens.push(current.join(''));
    }
    return tokens.join('_').toLowerCase();
}

function capitalize(value) {
    if (!value) return '';
    return value.split(' ').map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    ).join(' ');
}

function titlefy(slug) {
    if (!slug) return '';
    return slug.toLowerCase().split('_').map(
        (subslug) => subslug.charAt(0).toUpperCase() + subslug.substr(1).toLowerCase(),
    ).join(' ');
}

export {
    titlefy,
    slugify,
    capitalize,
};
